// Token generator untuk integrated.injourney.id API
// Menggunakan cara yang sama seperti di integrated.injourney.id
import CryptoJS from 'crypto-js';

/**
 * Generate token untuk integrated.injourney.id API
 * Format sama seperti di integrated.injourney.id menggunakan jwt.sign
 * 
 * Payload structure:
 * {
 *   userId: nip,
 *   username: nip,
 *   email: email
 * }
 * 
 * Secret: 'ingDLMRuGe9UKHRNjs7cYckS2yul4lc3'
 * Expires: 24h
 * 
 * @param {Object} userData - Data user dari login response
 * @returns {string} JWT Token yang di-generate
 */
export const generateTokenWithSignature = (userData) => {
  const secret = 'ingDLMRuGe9UKHRNjs7cYckS2yul4lc3';
  
  // Payload sesuai dengan format di integrated.injourney.id
  const payload = {
    userId: userData.nip || userData.sub || userData.userId,
    username: userData.nip || userData.username,
    email: userData.email || userData.nip || userData.username
  };

  // JWT Header
  const header = {
    alg: 'HS256',
    typ: 'JWT'
  };

  // Base64 URL encode header dan payload
  const base64UrlEncode = (str) => {
    return btoa(JSON.stringify(str))
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  };

  const encodedHeader = base64UrlEncode(header);
  const encodedPayload = base64UrlEncode(payload);

  // Generate signature using HMAC SHA256
  const signature = CryptoJS.HmacSHA256(
    `${encodedHeader}.${encodedPayload}`,
    secret
  ).toString(CryptoJS.enc.Base64)
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');

  // Return JWT token: header.payload.signature
  return `${encodedHeader}.${encodedPayload}.${signature}`;
};

